<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OffersList from "./offres";
import SuppliersApi from "@/services/suppliers-api";


/**
 * Projects-list component
 */
export default {
  page: {
    title: "Liste des Offres LGP NEGOCE",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,  OffersList },
  data() {
    return {
      daterange: null,
      suppliersList:[],
      selected:null,
      selectedSupplier: 594896723272,
      before:null,
      after:null,
      start:null,
      end:null,

    };
  },

  mounted(){
    this.getSuppliers()
  },

  methods :{
    getSuppliers(){
      SuppliersApi.getAllSuppliers(true).then(
        response => {
          this.suppliersList=response;
        }
      )
    }

  },

  watch: {
        selected: function() {
            this.selectedSupplier = this.selected ? this.selected.id : null
        },
        end: function(){
          this.before = this.end? this.end : null
        },
        start: function(){
          this.after  = this.start? this.start : null
        }
    }
};
</script>
<template>
  <Layout>
    <div class="row  pt-4">
      <div class="col-lg-12">
        <div class="card border border-primary">
          <div class="card-body">
            <h2 class="card-title text-primary font-size-25" style="font-size:25px;">Offres LGP Negoce</h2>
            <p class="card-title-desc font-size-14 pb-0 mb-0">
              La liste des offres groupées proposées par LGP NEGOCE
            </p>
               

          </div>
        </div>
      </div>
    </div>
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
          <OffersList :selectedSupplier.sync=this.selectedSupplier :before.sync=this.before :after.sync=this.after :isGroupedPromotions=true />
      </div>
    </div>
   
  </Layout>
</template>